const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-spider', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			chartData: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nnchartspider-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			console.log('spider component');
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		destroyed: function () {

		},
		methods: {
			setupChart: function () {
				const maxValue = 10.0;
				const chartData = this.chartData;
				const values = chartData.Values[0];
				const average = chartData.Average[0];
				const max = chartData.Max[0];
				const names = chartData.Names[0].Names.split(';');
				const keys = chartData.Names[0].Keys.split(';');

				const doelgroepData = [];

				//hover ticks... with max points
				doelgroepData.push($.extend({}, this.getDefaultChartArea(), {
					name: 'Tooltip Area',
					data: keys.map(k => maxValue),
					color: globalColors.primary.hue7,
					animation: false,
					fillColor: 'transparent',
					showInLegend: false,
					marker: {
						radius: 2,
						fillColor: globalColors.brand1.dark,
						states: {
							hover: {
								enabled: false
							},
							select: {
								enabled: false
							}
						}
					}
				}));

				doelgroepData.push($.extend({}, this.getDefaultChartArea(), {
					name: 'Average',
					color: globalColors.primary.hue6, //grey
					data: keys.map(k => Math.min(maxValue - 0.1, (parseFloat(average[k]) / parseFloat(max[k])) * maxValue)),
					value: keys.map(k => average[k]),
					max: keys.map(k => max[k])
				}));

				doelgroepData.push($.extend({}, this.getDefaultChartArea(), {
					name: chartData.ValueTitle,
					color: globalColors.brand1.dark, //yellow
					data: keys.map(k => Math.min(maxValue - 0.1, (parseFloat(values[k]) / parseFloat(max[k])) * maxValue)),
					value: keys.map(k => values[k]),
					max: keys.map(k => max[k])
				}));


				vuelog(doelgroepData);
				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						polar: true,
					},
					pane: {
						startAngle: 0,
						endAngle: null,
						background: {
							backgroundColor: globalColors.primary.hue2,
							outerRadius: '100%',
							borderColor: 'transparent'
						}
					},
					tooltip: {
						useHTML: true,
						outside: true,
						backgroundColor: globalColors.primary.hue9,
						formatter: function () {
							/* Only show the tooltip if the first series, namely the 'Max' series */
							if (this.series.index == 0) {
								const average = doelgroepData[1].value[this.x];
								const max = doelgroepData[1].max[this.x];
								const customer = doelgroepData[doelgroepData.length - 1].value[this.x];
								return `<span style='color: ${globalColors.brand1.dark}'>val: ${customer}</span><br/>avg: ${average}<br/>max: ${max}`;
							}
							return false;
						}
					},
					xAxis: {
						tickInterval: 1,
						labels: {
							formatter: function () {
								return names[this.value];
							},
							style: {
								color: globalColors.primary.hue9
							}
						},
						lineColor: 'transparent',
						gridLineColor: globalColors.primary.hue3,
						lineWidth: 1,
						tickWidth: 1,
						tickColor: globalColors.primary.hue3
					},
					yAxis: {
						tickInterval: 1,
						max: maxValue,
						labels: {
							enabled: false
						},
						lineColor: globalColors.primary.hue3,
						gridLineColor: globalColors.primary.hue3,
						lineWidth: 1,
						tickWidth: 1,
						tickColor: globalColors.primary.hue3
					},
					plotOptions: {
						series: {
							pointStart: 0,
							pointInterval: 1,
							lineWidth: 0,
						}
					},
					series: doelgroepData,
					legend: {
						enabled: true,
						align: 'left',
						verticalAlign: 'top',
						layout: 'vertical',
						symbolRadius: 0,
						reversed: true,
						floating: true,
						itemStyle: {
							color: globalColors.primary.hue9
						},
						itemHoverStyle: {
							color: globalColors.primary.hue8
						},
						itemHiddenStyle: {
							color: globalColors.primary.hue1
						}
					},

				}));
				this.$emit('chartReady', this.chart);
			},
			getDefaultChartArea: function () {
				return {
					type: 'area',
					marker: {
						symbol: 'circle',
						radius: 0,
						enabled: false,
						states: {
							hover: {
								lineWidth: 0,
								lineWidthPlus: 0
							}
						}
					},
					states: {
						hover: {
							enabled: false
						},
						select: {
							enabled: false
						}
					}
				};
			}
		}
	})
})();
